<section>
  @if (!isFirstStep) {
  <app-enrollment-banner></app-enrollment-banner>
  }
  <div class="row pt-3 d-md-none">
    <div class="col-6">
      <a (click)="$event.preventDefault();goToPreviousStep()" class="font-weight-normal" href="#">
        <fa-icon [icon]="['fas', 'arrow-left']" class="pr-1"></fa-icon>
        {{ backLabel | translate}}</a
      >
    </div>
    <div class="col-6 text-right">
      <span class="text-uppercase font-weight-normal">
        {{'wizard.stepLabelMobile' | translate: { 'current': stepNumber, 'total': stepsTotal } }}
      </span>
    </div>
  </div>
  <div class="container px-0 px-md-3 mt-md-5 mt-4 mb-4 align-items-center">
    <div class="row">
      <div class="col-md-9 col-sm-12">
        <h1 class="mb-3">{{title}}</h1>
        @if (showTips) {
        <span class="d-none d-md-block mb-5 required-field-preview">{{ 'common.tooltips.requiredFields' | translate }}</span>
        }
        <span [innerHTML]="descr" class="d-block"></span>
      </div>
      <div class="col-3 d-none d-md-block">
        <button (click)="goToPreviousStep()" class="btn btn-outline-success btn-lg btn-block" type="button">
          {{ backLabel | translate }}
        </button>
      </div>
    </div>

    <ng-content></ng-content>

    @if (showNextButton) {
    <div class="row justify-content-center justify-content-md-end">
      <div class="col-md-3 col-8">
        @if (!lastStep) {
        <button (click)="goToNextStep()" class="btn btn-success btn-lg btn-block" type="button" [disabled]="isSubmitting">
          {{ 'wizard.actions.continue' | translate }}
        </button>
        } @if (lastStep) {
        <button (click)="finishForm()" class="btn btn-success btn-lg btn-block" type="button" [disabled]="isSubmitting">
          {{ 'wizard.actions.finish' | translate }}
        </button>
        }
      </div>
    </div>
    } @if (postSubmitSectionContent) {
    <div class="row mt-md-4 mt-5">
      <div [innerHTML]="postSubmitSectionContent" class="col-12"></div>
    </div>
    }
  </div>
</section>
